// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"494":"34a2d3b5","612":"7a7a0bda"}[chunkId] + ".chunk.css";
};